module.exports = __webpack_public_path__ + "media/images/background_hero-323c3a83c2334d6af4e5c0be0bfe8cfd.png";